export enum UploadConfiguration {
  /** These constants are used to determine the max uploaded file size which is different on different places
   * They are used as switch case as option in src/helper/files.ts -> checkFileSizeBeforeUpload(file, options)
   */
  SIZE_NORMAL = "normal", //up to 2MB
  SIZE_CONFIGURATION = "configuration", //up to 1MB
  SIZE_MULTI_PAGES = "multipages", //up to 10MB
}
